import { AppData, Lightning, Log, Utils } from '@lightningjs/sdk'
import { Helper } from '../lib/helper';
import { Platform } from '../platforms/platform';
import { AppSetup } from '../lib/app-setup';

export interface CCItemTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

const controlsTextColor = 0xffffffff;
const controlsTextColorFocus = 0xffffffff;
const controlsTextColorSelected = 0xffff0000;
const controlsBGColorSelected = 0xffffffff;
const controlsBGColorFocus = 0xffff0000;
const controlsBGColor = 0xff000000;


export default class CCItem
  extends Lightning.Component<CCItemTemplateSpec>
  implements Lightning.Component<CCItemTemplateSpec> {
  selected = false
  content = ''
  itemIndex = 0
  private _focusAnimation: Lightning.types.Animation | undefined = undefined
  static override _template(): Lightning.Component.Template<CCItemTemplateSpec> {
    return {
      w: (w: any) => w,
      h: (h: any) => h,
      Label: {
        x: 0,
        y: 0,
        text: {
          text: "",
          fontSize: 28,
          textColor: 0xffffffff,
          fontFace: Helper.getFontFamily('Regular'),
        },
      },
      ValueBox: {
        x: 0,
        y: 50,
        w: 445,
        h: 56,
        zIndex: 41,
        rect: true,
        collision: true,
        color: 0xffffffff,
        shader: { type: Lightning.shaders.RoundedRectangle, radius: 5 },
        Value: {
          x: 20,
          y: 30,
          mountY: 0.5,
          text: {
            text: "",
            fontSize: 26,
            textColor: 0xff0d0d1d,
            fontFace: Helper.getFontFamily('Black')
          }
        },
        Arrow: {
          x: 420,
          y: 30,
          mountX: 1,
          mountY: 0.5,
          texture: {
            type: Lightning.textures.ImageTexture,
            src: Utils.asset('images/up_arrow.png'),
            resizeMode: {
              h: 24,
              w: 24,
              type: 'contain',
            }
          }
        }
      }
    }
  }

  override _handleEnter() {
    this.fireAncestors('$ItemSelected', this.itemIndex)
    return true
  }

  override _init() {
  }

  update() {
    const isFocused = this.hasFocus()

    // Focus = Red (User Request)
    // Selected = White (Existing logic, presumably for active state)
    // Default = Dark Grey

    let boxColor = 0xffffffff
    let textColor = 0xff0d0d1d

    if (isFocused) {
      boxColor = 0xffff0000
      textColor = 0xffffffff
    } else if (this.selected) {
      boxColor = 0xffffffff
      textColor = 0xff0d0d1d
    }

    this.tag('ValueBox').setSmooth('color', boxColor)
    this.tag('ValueBox.Value').setSmooth('text.textColor', textColor)
    // this.tag('ValueBox.Arrow').setSmooth('text.textColor', textColor)
  }

  override _focus() {
    this.update()
  }

  override _unfocus() {
    this.update()
  }

  set itemSelected(itemSelected: any) {
    this.selected = itemSelected || false
    Log.info('CCItem itemSelected: ', this.selected)
    this.update()
  }
  set item(itemInfo: any) {
    Log.info('CCItem setItem: ', itemInfo.name)
    this.tag('Label').text.text = itemInfo.name

    // Find active option to display as value
    if (itemInfo.options) {
      let activeOpt = itemInfo.options.find((opt: any) => opt.isActive)
      if (activeOpt) {
        this.tag('ValueBox.Value').text.text = activeOpt.name
      } else {
        this.tag('ValueBox.Value').text.text = ''
      }
      this.tag('ValueBox.Arrow').visible = true
    } else {
      // Special case for Reset
      this.tag('ValueBox.Value').text.text = 'Reset'
      this.tag('ValueBox.Arrow').visible = false
    }
  }

  _handleClick(target: any) {
    console.log('CCItem _handleClick : ', target, this.itemIndex)
    this.fireAncestors('$ItemSelected', this.itemIndex)
  }

  _handleHover(target: any) {
    this.fireAncestors('$ItemHovered' as any, this.itemIndex)
  }

  set isOpened(opened: boolean) {
    this.tag('ValueBox').zIndex = opened ? 0 : 41;
  }
}
